import { render, staticRenderFns } from "./avoided-costs.vue?vue&type=template&id=761e5fa9&scoped=true"
import script from "./avoided-costs.vue?vue&type=script&lang=js"
export * from "./avoided-costs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761e5fa9",
  null
  
)

export default component.exports